import { selectDishes } from 'app/utils/dish';
import { sortBy } from 'lodash';
import { CATEGORIES_ORDER } from 'app/const/categories';
import { useMemo } from 'react';
import { useMenuDishes } from './useMenuDishes';

export const useDishesSelection = ({
    period,
    configDishes = [],
    categoryId,
    tags = [],
}) => {
    const {
        allDishes,
        basketDishes,
    } = useMenuDishes({
        selectedPeriod: period,
        fetchPolicy: 'cache-first',
        autoFetch: true,
    });

    return useMemo(() => {
        if (!allDishes.length) return [];

        let dishes = selectDishes(
            allDishes,
            categoryId || null,
            [],
            null,
            basketDishes,
        );

        if (tags.length) {
            dishes = dishes.filter((dish) => dish.tags?.some((tag) => tags.includes(tag.id)),
            );
        }

        if (configDishes.length) {
            dishes = dishes.filter((dish) => configDishes.includes(dish.id),
            );

            const dishesMap = new Map(
                dishes.map((dish) => [dish.id, dish]),
            );

            return configDishes
                .map((id) => dishesMap.get(id))
                .filter(Boolean);
        }

        return sortBy(
            dishes,
            CATEGORIES_ORDER
                .map((category) => (dish) => String(dish.categoryId) === category,
                )
                .reverse(),
        );
    }, [
        allDishes,
        basketDishes,
        configDishes,
        categoryId,
        tags,
    ]);
};
